import {initLiveChat} from "@js/parts/globals/initLiveChat";

$(document).ready(function()
{
	initLiveChat();
	$(document).on('click','#cn-accept-cookie',function(){
		initLiveChat();
	});
});

